import React, { useState, useEffect, useRef } from "react";
import ReportsHelpers from "../../utils/ReportsHelpers";
import ReportCount from "../reports/ReportCount";
import ElementReport from "../elements/ElementReport";
import readReportCount from "../../utils/readReportCount";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const StepReport = (props) => {
  const step = props.step;
  const idPrefix = props.reportIdPrefix || "";
  const elements = [];
  const conversionRate = useRef(null);
  const conversionBar = useRef(null);
  const defaultConversionRate = step.conversions
    ? ((step.conversions / step.views) * 100).toFixed(2)
    : 0.0;
  const defaultConversionProgress = (
    (step.conversions / props.firstStep.conversions) *
    100
  ).toFixed(2);

  step.sections
    .filter((section) => !section.content_toggle_item_id)
    .forEach((section) => {
      section.elements
        .filter(
          (element) =>
            [
              "form",
              "button",
              "survey",
              "products",
              "quiz",
              "product_hero",
              "scheduler",
              "conditional_row",
              "collapse",
              "tabs",
              "carousel",
              "embed",
            ].includes(element.element_type) &&
            (element.element_type !== "button" ||
              element.options["disable-conversion"] !== "true" ||
              element.options["confirmation-close"] !== "true")
        )
        .forEach((element) => {
          elements.push(element);
        });
    });

  const updateConversionRate = (
    step,
    conversionRateElement,
    conversionBarElement
  ) => {
    const viewsSpan = $(`#${idPrefix}step-${step.id}-views`);
    const conversionsSpan = $(`#${idPrefix}step-${step.id}-conversions`);

    const views = readReportCount(viewsSpan);
    const conversions = readReportCount(conversionsSpan);

    let conversionRateValue = conversions > 0 ? (conversions / views) * 100 : 0;

    if (conversionRateValue > 100) {
      conversionRateValue = 100.0;
    }

    $(conversionRateElement).text(conversionRateValue.toFixed(2));

    const firstStepConversionsSpan = $(
      `#${idPrefix}step-${props.firstStep.id}-conversions`
    );
    const firstStepConversions = readReportCount(firstStepConversionsSpan);
    let conversionBarValue =
      conversions > 0
        ? ((conversions / firstStepConversions) * 100).toFixed(2)
        : 0;

    if (conversionBarValue > 100) {
      conversionBarValue = 100.0;
    }

    $(conversionBarElement)
      .css("width", `${conversionBarValue}%`)
      .attr("aria-valuenow", conversionBarValue);
  };

  return (
    <React.Fragment>
      <div
        className="row hard-center some-vertical-space StepReport"
        style={{
          paddingBottom: "15px",
          borderBottom: "1px solid #E9EBf1",
          minWidth: props.minWidth || "750px",
        }}
      >
        <div className="col-xs-12">
          <h4 className="bold" style={{ margin: "0 0 8px" }}>
            Step {step.position}
            {step.options && step.options["name"]
              ? ` - ${step.options["name"]}`
              : ""}
          </h4>
          <p className="light">
            <ReportCount
              inline={true}
              id={`${idPrefix}step-${step.id}-views`}
              path={`/websites/${props.cta.website_id}/events_reports`}
              payload={{
                report_type: "distinct_count",
                report: {
                  website_id: props.cta.website_id,
                  event_type: "View",
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: step.variant_id,
                  step_id: step.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  broadcast_id: null,
                },
              }}
              callback={() => {
                updateConversionRate(
                  step,
                  conversionRate.current,
                  conversionBar.current
                );
              }}
            />{" "}
            people saw this funnel step and{" "}
            <ReportCount
              inline={true}
              id={`${idPrefix}step-${step.id}-conversions`}
              path={`/websites/${props.cta.website_id}/events_reports`}
              payload={{
                report_type: "distinct_count",
                report: {
                  website_id: props.cta.website_id,
                  event_type: "Complete",
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: step.variant_id,
                  step_id: step.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  element_id: null,
                  broadcast_id: null,
                },
              }}
              callback={() => {
                updateConversionRate(
                  step,
                  conversionRate.current,
                  conversionBar.current
                );
              }}
            />{" "}
            converted (
            <span
              id={`${idPrefix}step-${step.id}-conversion-rate`}
              ref={conversionRate}
            >
              {props.timeframeType == "All Time"
                ? defaultConversionRate
                : "0.00"}
            </span>
            %).
            <FunnelTrackedMetrics
              idBase={`${idPrefix}step-${step.id}`}
              path={`/websites/${props.cta.website_id}/events_reports`}
              currency={props.currency}
              reportingGoals={props.reportingGoals}
              gateReports={props.gateReports}
              report={{
                website_id: props.cta.website_id,
                range_start: props.range_start,
                range_end: props.range_end,
                contactable_type: "Cta",
                contactable_id: props.cta.id,
                variant_id: step.variant_id,
                step_id: step.id,
                element_id: null,
                field: null,
                value: null,
                product_id: null,
                broadcast_id: null,
              }}
            />
          </p>
        </div>
        <div className="col-xs-12">
          <div
            className="progress"
            style={{ backgroundColor: "#DEE6FD", height: "15px" }}
          >
            <div
              ref={conversionBar}
              className="progress-bar"
              role="progressbar"
              style={{
                width:
                  props.timeframeType == "All Time"
                    ? `${defaultConversionProgress}%`
                    : undefined,
                backgroundColor: "#003FFF",
              }}
              aria-valuenow={
                props.timeframeType == "All Time"
                  ? `${defaultConversionProgress}%`
                  : undefined
              }
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <div className="col-xs-12 element-reports">
          {elements.map((element) => {
            return (
              <ElementReport
                key={`element-${element.id}`}
                cta={props.cta}
                step={step}
                element={element}
                timeframeType={props.timeframeType}
                range_start={props.range_start}
                range_end={props.range_end}
                externalProductValues={props.externalProductValues}
                hide_stats={[
                  "collapse",
                  "tabs",
                  "carousel",
                  "conditional_row",
                ].includes(element.element_type)}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                reportIdPrefix={idPrefix}
              />
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default StepReport;
